import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../helper/api";

export const favoriteGameList = createAsyncThunk(
  "favoriteGameList/favoriteGameList",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get(`/favouritesGames?page=${payload.page}?perPage=${payload.perPage}?search=${payload.search}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const favoriteGameListSlice = createSlice({
  name: "favoriteGameList",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(favoriteGameList.pending, (state) => {
        state.loading = true;
      })
      .addCase(favoriteGameList.fulfilled, (state, action) => {
          
          
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(favoriteGameList.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default favoriteGameListSlice.reducer;
